import { selectUser } from "src/store/authSlice";
import { useSelector } from "src/store/Store";

const useMemberMaster = () => {
  const { auth } = useSelector(selectUser);

  return auth === "MA0001";
};

export default useMemberMaster;
